module.exports = __webpack_public_path__ + "fonts/icon_set_1.f1e83c79.eot";